module.exports = __webpack_public_path__ + "img/MAC1120_L.b99f436d.png";